
const BusinessPartnerRoutes = [
    {
        path: '',
        name: 'business-partner-index',
        component: () => import("@/components/admin/business-partner/list.vue"),
    },
    {
        path: 'list',
        name: 'list-business-partner',
        component: () => import("@/components/admin/business-partner/list.vue"),
    },
    {
        path: 'form',
        name: 'form-business-partner',
        component: () => import("@/components/admin/business-partner/form.vue"),
    }
];
export default BusinessPartnerRoutes